import axios from "@/plugins/axios";
export const state = () => ({
  shopsStocks: [],
  unit_Info: [],
});

export const mutations = {
  SET_SELECTED_SHOP_STOCK(state, payload) {
    state.shopsStocks = payload;
  },
  SET_STOCK_UNIT_INFO(state, payload) {
    state.unit_Info = payload;
  },
};

export const actions = {
  async shopStocks({ commit, state }, payload) {
    return new Promise((resolve, reject) => {
      axios
        .get(
          `/reports/shops/${payload.id}/products?shops=${payload.shop}&brand=${
            payload.brand
          }&category=${payload.category}&page=${1}&size=${20}&querys=${
            payload.query
          }`
        )

        .then((res) => {
          if (res.data.data) {
            commit("SET_SELECTED_SHOP_STOCK", res.data.data);
            resolve(res.data.data);
          } else {
            let data = [];
            commit("SET_SELECTED_SHOP_STOCK", data);
            resolve(data);
          }
        })
        .catch((err) => {
          reject(err);
        });
    });
  },

  async shopStocksUnit({ commit, state }, payload) {
    return new Promise((resolve, reject) => {
      axios
        .get(
          `/reports/shops/${payload.id}/products/${payload.product_id}?batch=${payload.batch}&unit=${payload.unit}&convertUnit=${payload.convertUnit}`
        )
        .then((res) => {
          commit("SET_STOCK_UNIT_INFO", res.data.data);
          resolve(res.data.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
};

export const getters = {
  GetShopStock(state) {
    return state.shopsStocks ? state.shopsStocks : null;
  },
  GetUnitInfo(state) {
    return state.unit_Info;
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
